import {EffectiveEntryStatus} from '../../../../helpers/effective-entry-status'
import type {StackSectionStackEntry} from '../../../../helpers/merge-box-status-calculator/stack-section-types'

// The server rejects stacked auto-merge when this pull request or a pull request below it is a draft, has merge
// conflicts, needs to be rebased onto the pull request below it, or is closed.
const BLOCKING_STATUSES = new Set<EffectiveEntryStatus>([
  EffectiveEntryStatus.Closed,
  EffectiveEntryStatus.Draft,
  EffectiveEntryStatus.MergeConflicts,
  EffectiveEntryStatus.NeedsRebase,
])

// Merged and queued pull requests below this one are left out of stacked auto-merge, but it can't start from one.
const CURRENT_ONLY_BLOCKING_STATUSES = new Set<EffectiveEntryStatus>([
  EffectiveEntryStatus.Merged,
  EffectiveEntryStatus.Queued,
])

export function hasStackAutoMergeBlocker(entries: readonly StackSectionStackEntry[] | undefined): boolean {
  return (entries ?? []).some(({position, effectiveEntryStatus}) => {
    if (!effectiveEntryStatus || position === 'AFTER') return false
    if (BLOCKING_STATUSES.has(effectiveEntryStatus)) return true

    return position === 'CURRENT' && CURRENT_ONLY_BLOCKING_STATUSES.has(effectiveEntryStatus)
  })
}
